<template>
  <div>
    <div v-if="isAdmin">
      <router-link v-if="page && !item" to="/boss"
        ><v-icon color="primary" small>mdi-arrow-left</v-icon>Admin
        Home</router-link
      >
      <conditions-admin-home
        v-if="page && page == 'ocular-conditions'"
      ></conditions-admin-home>
      <ads-admin-home v-else-if="page && page == 'ads'"></ads-admin-home>
      <articles-admin-home
        v-else-if="page && page == 'articles'"
      ></articles-admin-home>
      <rgp-companies-admin-home
        v-else-if="page && page == 'rgp-companies'"
      ></rgp-companies-admin-home>
      <rgp-lenses-admin-home
        v-else-if="page && page == 'rgp-lenses'"
      ></rgp-lenses-admin-home>
      <rgp-materials-admin-home
        v-else-if="page && page == 'rgp-materials'"
      ></rgp-materials-admin-home>
      <billing-protocols-admin-home
        v-else-if="page && page == 'billing-protocols'"
      ></billing-protocols-admin-home>

      <!-- the menu -->
      <div v-else class="ma-2">
        <div class="text-h4">EyeDock Admin</div>
        <div class="ma-3">
          <v-btn to="/boss/ads" text color="primary">Ads Admin</v-btn>
        </div>
        <div class="ma-3">
          <v-btn to="/boss/articles" text color="primary">Articles Admin</v-btn>
        </div>
        <v-divider></v-divider>
        <div class="ma-3">
          <v-btn to="/boss/ocular-conditions" text color="primary"
            >Ocular Conditions</v-btn
          >
        </div>
        <div class="ma-3">
          <v-btn to="/boss/billing-protocols" text color="primary"
            >Billing Protocols</v-btn
          >
        </div>
        <v-divider></v-divider>
        <div class="ma-3">
          <v-btn to="/boss/rgp-companies" text color="primary"
            >RGP Companies</v-btn
          >
        </div>
        <div class="ma-3">
          <v-btn to="/boss/rgp-lenses" text color="primary">RGP Lenses</v-btn>
        </div>
        <div class="ma-3">
          <v-btn to="/boss/rgp-materials" text color="primary"
            >RGP Materials</v-btn
          >
        </div>
      </div>
    </div>
    <div v-else class="ma-8">
      <div>You are not logged in as an administrator.</div>
      <user-login
        buttonLabel="Log In"
        :textButton="false"
        class="my-2"
      ></user-login>
    </div>
  </div>
</template>

<script>
import UserMixin from "@/assets/js/UserMixin";
// import Name from "../dir/file";

export default {
  components: {
    ConditionsAdminHome: () =>
      import("@/components/adminStuff/ConditionsAdmin/ConditionsAdminHome.vue"),
    AdsAdminHome: () =>
      import("@/components/adminStuff/AdsAdmin/AdsAdminHome.vue"),
    ArticlesAdminHome: () =>
      import("@/components/adminStuff/ArticlesAdmin/ArticlesAdminHome.vue"),
    RgpCompaniesAdminHome: () =>
      import("@/components/adminStuff/RGPsAdmin/RgpCompaniesAdminHome.vue"),
    RgpLensesAdminHome: () =>
      import("@/components/adminStuff/RGPsAdmin/RgpLensesAdminHome.vue"),
    RgpMaterialsAdminHome: () =>
      import("@/components/adminStuff/RGPsAdmin/RgpMaterialsAdminHome.vue"),
    BillingProtocolsAdminHome: () =>
      import(
        "@/components/adminStuff/BillingProtocolsAdmin/BillingProtocolsHome.vue"
      ),
    UserLogin: () => import("@/components/universalStuff/UserLogin"),
  },
  name: "AdminHome",
  mixins: [UserMixin],
  props: {},
  data: function () {
    return { page: null, item: null };
  },
  methods: {},
  computed: {},
  mounted() {
    this.page = this.$route?.params?.page ? this.$route.params.page : null;
    this.item = this.$route?.params?.item ? this.$route.params.item : null;
  },
};
</script>

<style scoped></style>
